import SsoLogin from './SsoLogin';
export default SsoLogin;